import { API } from "./API";

export class BookingView {
  constructor() {
    this.bookingId = this.getBookingId();
    this.initialize();
  }

  getBookingId() {
    const path = window.location.pathname;
    const matches = path.match(/\/booking\/(\d+)/);
    return matches ? matches[1] : null;
  }

  async initialize() {
    if (this.bookingId) {
      await this.loadBookingData();
      this.setupEventListeners();
    } else {
      console.error("No booking ID found");
      window.location.href = "/admin/";
    }
  }

  async loadBookingData() {
    try {
      const data = await API.getBooking(this.bookingId);
      if (data.success) {
        this.renderBookingData(data.booking);
      } else {
        alert("Error loading booking data");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error loading booking data");
    }
  }

  renderBookingData(booking) {
    // Update header info
    document.getElementById(
      "bookingNumber"
    ).textContent = `Бронь № ${booking.booking_number}`;

	// booking.travel_date
    const bookingDate = new Date();
    const day = String(bookingDate.getDate()).padStart(2, "0");
    const months = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    const month = months[bookingDate.getMonth()];
    const year = bookingDate.getFullYear();
    document.getElementById(
      "bookingDate"
    ).textContent = `${day} ${month} ${year} г.`;

    if (booking.closed_for_brokers) {
      const closedForBrokers = document.createElement("div");
      closedForBrokers.textContent = "Закрыто для Брокеров";
      closedForBrokers.className =
        "bg-gray-300 p-2 rounded-md text-center font-bold text-[#203E99]";

      document.getElementById("closedForBrokers").appendChild(closedForBrokers);
    }

    // Update all fields
    document.getElementById("source").textContent = booking.source || "—";
    document.getElementById("boat").textContent = booking.boat || "—";
    document.getElementById("upgrade").textContent = booking.upgrade || "—";
    document.getElementById("clientName").textContent =
      booking.client_name || "—";
    document.getElementById("phone").textContent = booking.phone || "—";
    document.getElementById("travelDate").textContent =
      this.formatDate(booking.travel_date) || "—";
    document.getElementById("departureTime").textContent =
      booking.departure_time || "—";
    document.getElementById("duration").textContent = booking.duration
      ? `${booking.duration} ч.`
      : "—";
    document.getElementById("guests").textContent = booking.guests_count || "—";
    document.getElementById("rentalCost").textContent =
      booking.rental_cost || "—";
    document.getElementById("deposit").textContent = booking.deposit || "—";
    document.getElementById("onboardPayment").textContent =
      booking.onboard_payment || "—";
    document.getElementById("comments").textContent = booking.comments || "—";
  }

  formatDate(dateString) {
    if (!dateString) return "—";
    const date = new Date(dateString + ' 12:00:00');
    return date.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  setupEventListeners() {
    document.getElementById("editButton").addEventListener("click", () => {
      window.location.href = `/admin/booking/${this.bookingId}/edit`;
    });
  }
}
